import { Branch } from "@/app/branchs/branchs.type";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import { t } from "i18next";
import ExpensesBranchChart from "../Charts/ExpensesBranchChart";
import ExpensesBranchDaysChart from "../Charts/ExpensesBranchDaysChart";
import ExpensesBranchCategoryChart from "../Charts/ExpensesBranchCategoryChart";
import ExpensesBranchCategoryDaysChart from "../Charts/ExpensesBranchCategoryDaysChart";

export type ExpensesProps = {
  branches: Branch[];
};

const ExpensesComponent: React.FC<ExpensesProps> = ({ branches }) => {
  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.main_expenses")}
          description={t("user.views.main_message_expenses")}
        />
      </div>
      <div className="grid xl:grid-cols-2 lg:grid-cols-2 sm:grid-cols-1 md:grid-cols-1 gap-4 p-4">
        <div className="bg-white shadow rounded-lg p-4">
          <ExpensesBranchChart branches={branches} />
        </div>
        <div className="bg-white shadow rounded-lg p-4">
          <ExpensesBranchDaysChart branches={branches} />
        </div>
        <div className="bg-white shadow rounded-lg p-4">
          <ExpensesBranchCategoryChart branches={branches} />
        </div>
        <div className="bg-white shadow rounded-lg p-4">
          <ExpensesBranchCategoryDaysChart branches={branches} />
        </div>
      </div>
    </>
  );
};

export default ExpensesComponent;
